import { CalendarRef } from '@griply/types';

export const hasCalendarChanged = (
  picked: CalendarRef | null | undefined,
  current: CalendarRef | null | undefined,
): boolean => {
  if (!picked || !current) {
    return false;
  }

  return (
    picked.calendarId !== current.calendarId ||
    picked.connectionId !== current.connectionId
  );
};
